<template>
  <div v-bind="$attrs" class="midGrid h-full">

    <!-- Blue Header Row -->
    <!-- <div style="grid-row: 1; grid-column: 1; border-radius: 13px 13px 0 0;" class="w-full"/> -->
    <div style="grid-row: 1; grid-column: 1; border-radius: 13px 13px 0 0;" class="mbottom-12px w-full">
      <div class="mleft-06">
        <slot name="row1"></slot>
      </div>
    </div>

    <div class="mid-grid-body-bg midGrid-subGrid w-550">
      <!-- Header  -->
      <div v-if="$slots.row2">
        <div class="mleft-16px mtop-10">
          <slot name="row2"></slot>
        </div>
      </div>

      <!-- Upper-->
      <div class="mid-grid-row3 mid-grid-body-main" v-if="$slots.row3">
        <div class="mleft-20 mtop-10">
          <slot name="row3"></slot>
        </div>
      </div>

      <!-- Lower-->
      <div class="mid-grid-row4 mid-grid-body-main" v-if="$slots.row4">
        <itemScroll>
          <div class="mleft-20">
            <slot name="row4"></slot>
          </div>
        </itemScroll>
      </div>

      <!-- Combined "Upper + Lower"  -->
      <div class="mid-grid-row5 mid-grid-body-main" v-if="$slots.row5">
        <itemScroll>
          <div class="mleft-20">
            <slot name="row5"></slot>
          </div>
        </itemScroll>
      </div>

    </div>

  </div>
</template>


<script setup lang="ts">
</script>


<style scoped>
.midGrid {
  display: grid;
  grid-template-rows: auto 1fr 0.5rem;
}

.midGrid-subGrid {
  display: grid;
  grid-template-rows: max-content max-content 1fr;
}

.mid-grid-body-bg {
  border-radius: 8px;
  background-color:  var(--blue-04);
}

.mid-grid-body-main {
  background-color: var(--white);
  box-shadow: 0px 0px 2px 0px var(--NeutralInverseInverse8100);
  box-shadow: 0px 0px 4px 0px var(--NeutralInverseInverse450);
  box-shadow: 0px 0px 1px 0px var(--NeutralInverseInverse8100);
}

.mid-grid-row3 {
  border-radius: 8px 8px 0 0;
  padding-top: 16px;  
  margin: 16px 4px 0 4px;
}

.mid-grid-row4 {
  border-radius: 0 0 8px 8px;
  padding-bottom: 16px;
  padding-top: 16px;    
  margin: 0 4px 4px 4px;
}

.mid-grid-row5 {
  border-radius: 8px 8px 8px 8px;
  padding-bottom: 16px;
  padding-top: 16px;  
  margin: 16px 4px 4px 4px;
}

</style>